

let collapse = document.querySelectorAll(".collapsible")
collapse.forEach(tab => {
	tab.addEventListener('click', () => {
		tab.classList.toggle("active");
		let content = tab.nextElementSibling;
		if (content.style.maxHeight) {
			content.style.maxHeight = null;
		} else {
			content.style.maxHeight = content.scrollHeight + "px";
		}
	})
});

  
  